import SearchBar from './SearchBar'
import Alert from './Alert'
import CompositionCard from '../../features/composition-card/CompositionCard'
import PlayStyleFilter from './PlayStyleFilter'
import { useEffect, useState } from 'react'
import './search.css'
import { useLanguage } from '../../i18n/LanguageContext'

export default function CompositionSearch({
  searchTerm,
  setSearchTerm,
  debouncedTerm,
  filteredData,
  allComps,
  imageMap,
  itemComponents,
  itemImageMap,
  playStyleFilter,
  setPlayStyleFilter,
}) {
  const { t } = useLanguage()
  const [highlightCode, setHighlightCode] = useState(null)

  useEffect(() => {
    const seenHighlight = localStorage.getItem('seenHighlight')
    if (!seenHighlight && filteredData.length > 0) {
      setHighlightCode(filteredData[0].planner_code)
    }
  }, [filteredData])

  const handleHighlightSeen = () => {
    localStorage.setItem('seenHighlight', 'true')
    setHighlightCode(null)
  }

  return (
    <div className="search-wrapper">
      <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <PlayStyleFilter active={playStyleFilter} onChange={setPlayStyleFilter} />
      {debouncedTerm.length === 1 && (
        <Alert type="warning">{t('alert.minChars')}</Alert>
      )}
      {filteredData.map((entry) => (
        <CompositionCard
          key={entry.planner_code}
          composition={entry}
          pairs={entry.pairs
            .map((plannerCode) => allComps[plannerCode])
            .filter(Boolean)}
          imageMap={imageMap}
          itemComponents={itemComponents}
          itemImageMap={itemImageMap}
          highlight={entry.planner_code === highlightCode}
          onClick={handleHighlightSeen}
        />
      ))}
      {debouncedTerm.length >= 2 && filteredData.length === 0 && (
        <Alert type="error">{t('alert.noResults', { term: searchTerm })}</Alert>
      )}
    </div>
  )
}
